const TOKEN_KEY = 'agent_portal_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token || '');
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

